import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionStorageKeys } from '@app/core/models/configuration/sessionstorage-keys.model';
import { TableColumnsConfigHelper } from '@app/core/models/configuration/table-columns-config-helper';
import { TableColumnsConfigKey } from '@app/core/models/configuration/table-columns-config-key.model';
import { ImportModel } from '@app/core/models/imports/import.model';
import { ImportService } from '@app/core/services/import.service';
import { SessionStorageService } from '@app/core/services/session-storage.service';
import { ColumnDefinitionModel } from '@app/shared/models/column-definition.model';
import { TableActionIcon, TableIndication, TableRowAction } from '@app/shared/models/table-action-type.model';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-import-logs',
    templateUrl: './import-logs.component.html',
    styleUrls: ['./import-logs.component.scss']
})
export class ImportLogsComponent implements OnInit, OnDestroy {

    unsubscribe$: Subject<boolean> = new Subject<boolean>();
    imports: ImportModel[] = [];
    tableIndications: TableIndication[] = [];
    tableActions: TableRowAction[] = [];
    configKey: string;
    columnsDefinition: ColumnDefinitionModel[] = [];
    exportFileName: string;

    fromDate: string;
    toDate: string;

    public onFiltersCleared: EventEmitter<void> = new EventEmitter<void>();
    public onExportExcelCaller: EventEmitter<void> = new EventEmitter<void>();

    panelOpenState: boolean = true;
    title: string;

    constructor(private route: ActivatedRoute,
        private router: Router,
        private importService: ImportService,
        private sessionStorageService: SessionStorageService) {
          this.title = "HISTORIQUE DES IMPORTS";
    }

    ngOnInit(): void {
        this.route.data.subscribe((data: any) => {
            this.imports = data.imports;
            this.configKey = data.configKey;
            this.exportFileName = data.exportFileName;
        });

        this.columnsDefinition = new TableColumnsConfigHelper().getColumnsDefinition(TableColumnsConfigKey.IMPORTHISTORY);
        this.restoreFilters();
        this.initTableActions();
        this.initTableIndications();
    }

    restoreFilters() {
        const dateFilters = this.sessionStorageService.get<any>(SessionStorageKeys.IMPORTS_LOG);
        if (!_.isNil(dateFilters)) {
            if (!_.isNil(dateFilters.fromDate)) {
                this.fromDate = dateFilters.fromDate;
            }
            if (!_.isNil(dateFilters.toDate)) {
                this.toDate = dateFilters.toDate;
            }
        }
    }

    initTableActions() {
        this.tableActions.push(new TableRowAction(TableActionIcon.ZOOM, "Voir le détail", this.onZoom))
    }

    initTableIndications() {
        const isOk = (importRow: ImportModel) => importRow.Errors === 0;
        const isPartial = (importRow: ImportModel) => importRow.Errors > 0 && importRow.Errors < importRow.FilesCount;
        const isKO = (importRow: ImportModel) => importRow.Errors === importRow.FilesCount;
        this.tableIndications.push(new TableIndication(TableActionIcon.ADJUST, "Aucune erreur", isOk, 'indic-green'));
        this.tableIndications.push(new TableIndication(TableActionIcon.ADJUST, "Quelques erreurs", isPartial, 'indic-orange'));
        this.tableIndications.push(new TableIndication(TableActionIcon.ADJUST, "Tout en erreur", isKO, 'indic-red'));
    }

    onSubmit(): void {
        this.importService.getImports(this.fromDate, this.toDate)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((imports: ImportModel[]) => {
                this.imports = imports;
            })

        this.sessionStorageService.store(SessionStorageKeys.IMPORTS_LOG, { fromDate: this.fromDate, toDate: this.toDate });
    }

    onZoom = (importRow: ImportModel) => {
        this.router.navigate(['/administration/import-logs/', importRow.Id])
    }

    dateChangeSearch(result: any) {
      this.dateChange(result.type, result.selectedDate);
    }

    dateChange(type: string, selectedDate: any): void {

        var formated = !_.isNil(selectedDate) ? moment(selectedDate).format('YYYY-MM-DD') : null;

        switch (type) {
            case 'FromDate':
                this.fromDate = formated;
                break;
            case 'ToDate':
                this.toDate = formated;
                break;
        }

        this.onSubmit();
    }

    clearSearchFilter(): void {
      this.onClearFilters();
      this.onFiltersCleared.next();
    }

    onClearFilters = (): void => {
        this.fromDate = null;
        this.toDate = null;
        this.onSubmit();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
    }

    exportAsExcel() : void {
      this.onExportExcelCaller.next();
    }

    onShowFilter(panelvalue:boolean) {
      this.panelOpenState = panelvalue;
    }
}
